import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router';
import Url from 'url-parse';

import StarsModalRoutes from '@swf/components/StarsModalRoutes/StarsModalRoutes';
import type { Modal } from '@swf/core/models/modal';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';
import type { StaticContext } from '@swf/core/types/StaticContext';

const ModalRoute: React.FC<{ modal: Modal; staticContext?: StaticContext }> = ({
  modal,
  staticContext = {}
}) => {
  const {
    modal: { enqueue }
  } = useDispatch<Dispatch>();
  const embeddedAccount = useSelector(select.location.isEmbeddedAccount);

  staticContext.prefetch = ({ dispatch }, options) => {
    dispatch.location.update(new Url(options.href, true));
    return dispatch.page.fetchPage(options);
  };

  useEffect(() => {
    enqueue(modal);
  });

  if (embeddedAccount) {
    return <StarsModalRoutes setStyle={() => undefined} />;
  }

  return <Redirect to="/" />;
};

export default ModalRoute;
